<template>
	<v-card :outlined="outlined" v-bind="$attrs" v-on="$listeners">
		<slot />
	</v-card>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		outlined: {
			type: Boolean,
			default: false
		}
	}
};
</script>